export function cn(...classes: (string | undefined | false)[]) {
    return classes.filter(Boolean).join(' ');
}

export function getUIRoot() {
    return document.getElementById('root')!;
}

export function getUrlParam(name: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

export function ordinal(n: number): string {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] ?? s[v] ?? s[0]);
}

export function formatCurrency(value: number, currency: string) {
    const locale = navigator.language || navigator.languages[0] || 'en-GB';

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(value);
}

export function truncate(value: number) {
    return Math.trunc(value * 100) / 100;
}

export function cssVars(vars: Record<`--${string}`, string | number>) {
    return vars as React.CSSProperties;
}
